import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Demokratiewerkstatt} from "../../models/demokratiewerkstatt.model";
import {LegacyPageEvent as PageEvent, MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {DemokratiewerkstattService} from "../../services/demokratiewerkstatt.service";
import {Subscription} from "rxjs";
import {MatSort} from "@angular/material/sort";
import {Router} from '@angular/router';
import {ScrollPositionService} from '../../shared/services/scroll-position.service';

@Component({
  selector: 'app-demokratiewerkstatt',
  templateUrl: './demokratiewerkstatt.component.html',
  styleUrls: ['./demokratiewerkstatt.component.css']
})
export class DemokratiewerkstattComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  public showSpinner: boolean = true;
  public demokratiewerkstattList: Demokratiewerkstatt[] = [];
  public demokratiewerkstatt: Demokratiewerkstatt[] = [];
  public demokratiewerkstattSubscription: Subscription;

  public length: number = 0;
  public pageSize: number = 6;
  public pageSizeOptions: number[] = [3, 6, 9, 12];
  public sort: MatSort;
  protected isIconEmpty: boolean = true;
  protected isImgEmpty: boolean = false;
  protected showLogo: boolean = false;
  protected breakpoint: number;
  protected image: string =
    'https://res.cloudinary.com/dyekwrvwe/image/upload/v1709258959/placeholder_b3miif.jpg';
  private fullTitle: string = '';

  constructor(
    private readonly _workShortService: DemokratiewerkstattService,
    public router: Router,
    private scrollPositionService: ScrollPositionService
  ) {
  }

  ngOnInit(): void {
    this.windowScroll();
    this.getWorkshops();
    console.log('new page');
  }

  ngAfterViewInit(): void {

    setTimeout(() => {
      this.scrollPositionService.restoreScrollForUrl('/demokratiewerkstatt');
    }, 100);
  }

  ngOnDestroy(): void {
    const currentPosition = this.scrollPositionService.getCurrentScrollPosition();
    this.scrollPositionService.savePosition('/demokratiewerkstatt', currentPosition);

    if (this.demokratiewerkstattSubscription) {
      this.demokratiewerkstattSubscription.unsubscribe();
    }
  }

  public OnPageChange(event: PageEvent): void {
    let startIndex = event.pageIndex * event.pageSize;
    let endIndex = startIndex + event.pageSize;
    if (endIndex > this.length) {
      endIndex = this.length;
    }
    this.demokratiewerkstattList = this.demokratiewerkstatt.slice(startIndex, endIndex);
  }

  public getWorkshops(): void {
    this._workShortService.getWorkshops();
    this.demokratiewerkstattSubscription = this._workShortService.demokratiewerkstatt$
      .subscribe(
        (response: Demokratiewerkstatt[]) => {
          this.demokratiewerkstatt = response.map((demokratiewerkstatt) => {
            let subDes = demokratiewerkstatt.content.replace(/<(.+?)>/g, '');
            if (subDes.length > 140) {
              subDes = subDes.substring(0, 140);
              subDes = subDes.substring(0, subDes.lastIndexOf(' '));
              subDes += ' ...';
            }
            demokratiewerkstatt.content = subDes;
            demokratiewerkstatt.content = demokratiewerkstatt.content.substring(0, 250);
            if (typeof demokratiewerkstatt.sponsor_images_url === 'string') {
              try {
                demokratiewerkstatt.sponsor_images_url = this.convertStringToArray(
                  demokratiewerkstatt.sponsor_images_url
                );
              } catch (error) {
                demokratiewerkstatt.sponsor_images_url = [];
              }
            }

            if (
              demokratiewerkstatt.demokratiewerkstatt_icon_url == ' ' ||
              demokratiewerkstatt.demokratiewerkstatt_icon_url == null
            ) {
              this.isIconEmpty = false;
            }

            if (
              demokratiewerkstatt.demokratiewerkstatt_image_url == ' ' ||
              demokratiewerkstatt.demokratiewerkstatt_image_url == null
            ) {
              this.isImgEmpty = true;
            } else {
              this.isImgEmpty = false;
            }

            if (demokratiewerkstatt?.demokratiewerkstatt_icon_url?.startsWith("https")) {
              this.showLogo = false;
              demokratiewerkstatt.showLogo = true;
            } else {
              this.showLogo = true;
              demokratiewerkstatt.showLogo = false;
            }
            if (demokratiewerkstatt?.demokratiewerkstatt_image_url?.startsWith("https")) {
              this.showLogo = false;
              demokratiewerkstatt.showProjectImage = true;
            } else {
              this.showLogo = true;
              demokratiewerkstatt.showProjectImage = false;
            }
            this.fullTitle = demokratiewerkstatt.title;
            demokratiewerkstatt.fullTitle = this.fullTitle;
            demokratiewerkstatt.title =
              demokratiewerkstatt.title.length > 28
                ? demokratiewerkstatt.title.substring(0, 28) + ' ...'
                : demokratiewerkstatt.title;
            return demokratiewerkstatt;
          });

          this.demokratiewerkstatt = this.demokratiewerkstatt.sort((a, b) =>
            new Date(b.start_date!).getTime() - new Date(a.start_date!).getTime()
          );

          this.demokratiewerkstattList = this.demokratiewerkstatt.slice(0, 6);
          this.length = this.demokratiewerkstatt.length;
          this.showSpinner = false;
        }
      );
  }

  private windowScroll(): void {
    this.breakpoint = window.innerWidth <= 576 ? 1
      : window.innerWidth <= 992 ? 1
        : window.innerWidth <= 1200 ? 2
          : window.innerWidth <= 1400 ? 2
            : 3;
  }

  private convertStringToArray(inputString: string): string[] {
    return inputString.trim().startsWith('[') && inputString.trim().endsWith(']')
      ? inputString.slice(1, -1).split(',').map(element => element.trim().slice(1, -1))
      : [];
  }
}
